import { render, staticRenderFns } from "./homeTabOne.vue?vue&type=template&id=4964a7ea&scoped=true"
import script from "./homeTabOne.vue?vue&type=script&lang=js"
export * from "./homeTabOne.vue?vue&type=script&lang=js"
import style0 from "./homeTabOne.vue?vue&type=style&index=0&id=4964a7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4964a7ea",
  null
  
)

export default component.exports